<template>
    <div v-if="userInfo">
      <b-container fluid v-resize="onResize" v-bind:style="{height:treeHeight+'px'}" >
          <b-row class="full-height" style="padding: 0px;">
              <b-col md="5" class="full-height" v-show="(!isMobile || !isEditing)">                  
                  <div class="overflow full-height clipping">
                    
                    <b-navbar toggleable type="light" variant="light" sticky>
                      <div>                        
                        <b-button variant="light" size="sm" v-if="tree.modified" class="text-success" @click="publishMenu">Publish</b-button>
                        <b-button variant="light" size="sm" v-if="tree.modified" class="text-danger" @click="revertMenu">Revert</b-button>   
                        <b-button variant="light" size="sm" class="text-info" @click="previewMenu">Preview</b-button>                                           
                      </div>

                      <div right>
                        <b-button variant="primary" size="sm" v-if="isBusy">
                          <b-spinner small></b-spinner>
                        </b-button>
                        <b-button variant="link" size="sm" title="Undo" @click="menuUndo" :disabled="!enableUndo">
                          <i class="fas fa-undo-alt text-dark"></i>
                        </b-button>
                        <b-button variant="link" size="sm" title="Redo" @click="menuRedo" :disabled="!enableRedo">
                          <i class="fas fa-redo-alt text-dark"></i>
                        </b-button>
                      </div>
                    </b-navbar> 
                    
                    <draggable v-model="tree.sections" @end="onEndDraggable">
                      <tree-menu 
                        v-for="(node) in tree.sections" 
                        :depth="0"   
                        :node="node"
                        :parentNode="tree.sections"
                        :key="node.uuid"
                        :bus="bus" />
                    </draggable>
                  </div>
                  <b-button variant="primary" class="rounded-circle px-2 bottomright" @click="onAddChild">
                    <b-icon icon="plus" scale="2"></b-icon>
                  </b-button>
              </b-col>
              <b-col md="7" class="overflow full-height" v-show="(!isMobile || isEditing)"
                v-if="selectedNode && (selectedNode.method === 'edit' || selectedNode.method === 'addChild')">          
                
                <tree-menu-section 
                  v-if="selectedNode.depth === 0"
                  :node="selectedNode"
                  @onSubmit="onSubmit"
                  @onCancel="onCancel" />
                <tree-menu-item 
                  v-if="selectedNode.depth === 1"
                  :node="selectedNode"
                  @onSubmit="onSubmit"
                  @onCancel="onCancel" />
                <tree-menu-option-group
                  v-if="selectedNode.depth === 2"
                  :node="selectedNode"
                  @onSubmit="onSubmit"
                  @onCancel="onCancel" />
                <tree-menu-option 
                  v-if="selectedNode.depth === 3"
                  :node="selectedNode"
                  @onSubmit="onSubmit"
                  @onCancel="onCancel" />

                <pre v-if="false">
                  {{selectedNode}}
                </pre>
              </b-col>
          </b-row>
          
      </b-container>      
    </div>
    <b-container v-else>
        You dont have access MenuSetup    
    </b-container> 
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'

import TreeMenu from '@/components/portal/TreeMenu';
import TreeMenuSection from '@/components/portal/TreeMenuSection'
import TreeMenuItem from '@/components/portal/TreeMenuItem'
import TreeMenuOptionGroup from '@/components/portal/TreeMenuOptionGroup'
import TreeMenuOption from '@/components/portal/TreeMenuOption'


import draggable from 'vuedraggable'

export default {
    components : { TreeMenu, draggable, TreeMenuSection, TreeMenuItem, TreeMenuOptionGroup, TreeMenuOption },
    computed: { 
        ...mapState({
            userInfo:"userInfo",
            selectedLocation:'selectedLocation'
        }),
        tree() {
          return this.menuData;
        },
        enableUndo() {
          return this.menuHistory.length > 1;
        },
        enableRedo() {
          return this.menuRedoHistory.length > 0;
        }
    },
    data() {  
        return {
            isBusy : false,
            isMobile:false,
            isEditing : false,
            selectedNode : null,
            menuData : { sections:[] },
            menuHistory : [],
            menuRedoHistory : [],
            treeHeight : 0,
            bus: new Vue()
        }
    },
    watch : {    
      selectedLocation: {
        deep: true,
        immediate: true,
        handler() {
            this.selectedNode = null,
            this.menuData = { sections:[] }
            this.getMenuActive();    
        }
      }  
    },
    methods: {
      onResize() {
            let navheader = document.getElementById('navheader')            
            if(navheader){
                this.treeHeight = window.innerHeight - navheader.offsetHeight - 10;
            }
            this.isMobile = window.matchMedia('(max-width: 767px)').matches
        },
      getMenuActive() {
          this.isBusy = true;
          this.$store.dispatch('apiMenuActive')
                  .then(({status, res}) => {
                          this.isBusy = false;
                          if(status) {
                              this.menuData = res
                              if(!this.menuData.sections){
                                this.menuData.sections = []
                              }
                              this.menuData.sections.forEach((section, sIndex) => {                                                                
                                section.uuid = sIndex;                                //1
                                if(!section.items){
                                  section.items = []
                                }
                                section.items.forEach((item, iIndex) => {                                                                    
                                  item.uuid = `${section.uuid}-${iIndex}`                   //2
                                  if(!item.optionGroups){
                                    item.optionGroups = []
                                  }
                                  item.optionGroups.forEach((optionGroup, ogIndex) => {
                                    optionGroup.uuid = `${item.uuid}-${ogIndex}`      //3
                                    if(!optionGroup.options){
                                      optionGroup.options = []
                                    }
                                    optionGroup.options.forEach((option, oIndex) => {
                                      option.uuid = `${optionGroup.uuid}-${oIndex}`   //4
                                    })
                                  })
                                })
                              })
                            
                            {
                              this.menuHistory = [];
                              this.menuRedoHistory = [];
                              this.menuHistory.push(this.$deepCopy(this.menuData));
                            }
                          }
                  }).catch(e=>{ 
                    this.isBusy = false;
                    console.log("apiMenuActive-E", e)
                  })
      },
      findNodeByUUID(node, uuid) {
          if(node.uuid == uuid){
                return node;
          }
          let children = node.sections || node.items || node.optionGroups || node.options || null;
          if (children != null) {
                var i;
                var result = null;
                for(i=0; result == null && i < children.length; i++){
                    result = this.findNodeByUUID(children[i], uuid);
                }
                return result;
          }
          return null;
      },
      onAddChild(event) {
        this.bus.$emit('onSelectNode', { event : event, childs : this.tree.sections, method : "addChild", depth : 0 }); 
      },
      onSubmit(node) {
        if(this.selectedNode.method === "addChild") {
          node.uuid = this.$HashCode(Date.now() + "");
          this.selectedNode.childs.push(node);
        } else {
          // Vue.set(this.selectedNode, "node", node)
          Object.keys(this.selectedNode.node).forEach(key=>{
            this.selectedNode.node[key] = node[key];
          }) 
        }        
        this.isEditing = false;
        this.addMenuHistory();

        this.bus.$emit('selectedNode', null);//Send to already Open (TreeMenu)
        this.selectedNode = this.bus.selectedNode = null;  
      },
      onCancel() {
        this.isEditing = false;
        this.bus.$emit('selectedNode', null);//Send to already Open (TreeMenu)
        this.selectedNode = this.bus.selectedNode = null; 
      },
      menuUndo(){
        this.menuData = this.$deepCopy(this.menuHistory[this.menuHistory.length - 2]);
        this.menuRedoHistory.push(this.menuHistory.splice(-1,1)[0]);
        this.onCancel();
        this.updateMenu();
      },
      menuRedo(){
        this.menuData = this.$deepCopy(this.menuRedoHistory.splice(-1,1)[0]);
        this.menuHistory.push(this.$deepCopy(this.menuData));
        this.onCancel();
        this.updateMenu();
      },
      addMenuHistory() {
        this.menuHistory.push(this.$deepCopy(this.menuData));
        this.menuRedoHistory = [];        
        this.updateMenu();
      },
      onEndDraggable() {
        this.bus.$emit('onSelectNode', { method : "dragEnd" });
      },
      updateMenu() {
          this.isBusy = true;
          this.$store.dispatch('apiMenuActiveSave', this.menuData)
                      .then(({status}) => {
                          this.isBusy = false;
                          if(status) {
                            this.menuData.modified = true;
                            this.toast(this, { msg :  "Updated", variant : "success" , appendToast : false})
                            //Swal.fire('Updated', 'Menu has been updated.','success')
                          } else {
                              this.toast(this, { msg :  "Check Console", variant : "danger" })
                          }
                      }).catch(e=>{
                          this.isBusy = false;
                          this.toast(this, { msg :  e.msgError, variant : "danger" })
                          console.log("apiMenuActiveSave", e)
                            //Swal.fire('Error', e, 'error')
                      })
      },
      revertMenu() {
        this.isBusy = true;
        this.$store.dispatch('apiMenuActiveRevert')
                  .then(({status}) => {
                      this.isBusy = false;
                      if(status){
                          Swal.fire('Undo', 'Menu has been undo.', 'success')
                          this.getMenuActive()
                      }
                  })
                  .catch(e=>{
                      this.isBusy = false;
                      Swal.fire('Error', e, 'error')
                  })
      },
      publishMenu() {
        this.isBusy = true;
        this.$store.dispatch('apiMenuActivePublish')
                    .then(({status}) => {
                        this.isBusy = false;
                        if(status){
                            Swal.fire('Published', 'Menu has been Published.','success');
                            this.menuData.modified = false
                        }
                    })
                    .catch(e=>{
                        this.isBusy = false;
                        Swal.fire('Error', e, 'error')
                    })
      },
      previewMenu() {          
          let parseJson = this.menuData
          parseJson.sections.forEach(section=>{
              section.items.forEach(item=>{         
                  item._id = this.$HashCode(item.title)        // assign id for cart's options
              });
          })
          this.$store.dispatch('setMenu', parseJson);            
          let routeData = this.$router.resolve({ name: 'Menu Preview' });
          window.open(routeData.href, 'menuPreview');
      },
      onSelectNode(selectedNode) {
        if(selectedNode.method === "edit") {
          this.bus.$emit('selectedNode', selectedNode);//Send to already Open (TreeMenu)
          this.selectedNode = this.bus.selectedNode = selectedNode; //New Open Will get from here (TreeMenu)
          this.isEditing = true;
        }

        if(selectedNode.method === "delete") {
          if(this.selectedNode && (this.selectedNode.node.uuid === selectedNode.node.uuid)) {
            this.bus.$emit('selectedNode', null);//Send to already Open (TreeMenu)
            this.selectedNode = this.bus.selectedNode = null;   
          }
        }
        
        if(selectedNode.method === "copy" || selectedNode.method === "cut") {
          this.bus.$emit('selectedNode', selectedNode);//Send to already Open (TreeMenu)
          this.selectedNode = this.bus.selectedNode = selectedNode; //New Open Will get from here (TreeMenu)
        }        
        
        if(selectedNode.method === "paste") {
          this.bus.$emit('selectedNode', null);//Send to already Open (TreeMenu)
          this.selectedNode = this.bus.selectedNode = null;
        }

        if(selectedNode.method === "addChild") {
          this.bus.$emit('selectedNode', selectedNode);//Send to already Open (TreeMenu)
          this.selectedNode = this.bus.selectedNode = selectedNode;
          this.isEditing = true;          
        }

      }
    },
    created() {
      // this.$bvToast.show('my-toast')
      this.bus.$on('onSelectNode', (selectedNode) => {
        if(this.selectedNode && 
            ["paste", "delete", "dragEnd"].findIndex( _val => _val === selectedNode.method) < 0) {
            Swal.fire({
              title: 'Do you want to leave without save the changes?',
              showCancelButton: true,
              confirmButtonText: `Yes`,
            }).then((result) => {
              if (result.isConfirmed) {
                this.onSelectNode(selectedNode);
              }
            })
        } else {
          this.onSelectNode(selectedNode);
        }

        if(selectedNode.method === "paste" || selectedNode.method === "delete") {
          this.addMenuHistory()
        }

        if(selectedNode.method === "dragEnd") {
          this.addMenuHistory()
        }
      });
    },
    mounted() {
        //this.getMenuActive()
    },
    destroyed() {
     // this.bus.$off('onSelectNode');
    },
}
</script>

<style>
  .clipping {
    padding-bottom: 80px;
  } 
  .overflow {
    overflow: auto;
  }
  .full-height {
    height: 100%;
  }
  .bottomright {
     position: absolute;
     bottom: 0px;
     right: 35px;
  }

</style>